
//FIXME compare with instruction_queue

function Queue ({onAdded, onRemoved, onFinished, noWaiting} = {}) {
    this.onAdded    = onAdded
    this.onRemoved  = onRemoved
    this.onFinished = onFinished

    this.elements = []

    if (!noWaiting) {
        let queue = this
        this.waiting = new Queue({
            noWaiting: true,
            onRemoved: function (element) {
                if (queue.onRemoved) {
                    queue.onRemoved(element)
                }
            },
            onFinished: function () {
                checkFinished(queue)
            }
        })
    }
}


Queue.prototype.length = function () {
    return this.elements.length
}


Queue.prototype.empty = function () {
    return this.elements.length === 0
}


Queue.prototype.finished = function () {
    return this.empty() && (!this.waiting || this.waiting.empty())
}


Queue.prototype.has = function (element) {
    return this.elements.includes(element) || ((this.waiting || false) && this.waiting.has(element))
}


Queue.prototype.add = function (elementOrElements) {
    if (elementOrElements instanceof Array) {
        elementOrElements.forEach(element => simpleAdd(this, element))
        return undefined
    } else {
        return simpleAdd(this, elementOrElements)
    }
}


function simpleAdd (queue, element) {
    if (queue.has(element)) {
        return false
    } else {
        queue.elements.push(element)
        if (queue.onAdded) {
            queue.onAdded(element)
        }
        return true
    }
}


Queue.prototype.remove = function (element) {
    if (this.waiting && this.waiting.remove(element)) {
        return true
    }
    let index = this.elements.indexOf(element)
    if (index >= 0) {
        this.elements.splice(index, 1)
        if (this.onRemoved) {
            this.onRemoved(element)
        }
        checkFinished(this)
        return true
    } else {
        return false
    }
}


Queue.prototype.next = function (count) {
    if (this.empty()) {
        return null
    }

    if (count) {
        return this.elements.slice(0, count)
    } else {
        return this.elements[0]
    }
}


Queue.prototype.removeNext = function (count) {
    if (this.empty()) {
        return null
    }

    let removed
    if (count) {
        removed = this.elements.splice(0, count)
        if (this.onRemoved) {
            removed.forEach(element => this.onRemoved(element))
        }
    } else {
        removed = this.elements.shift()
        if (this.onRemoved) {
            this.onRemoved(removed)
        }
    }
    checkFinished(this)
    return removed
}




Queue.prototype.removing = function (element) {
    let index = this.elements.indexOf(element)
    if (index >= 0) {
        this.elements.splice(index, 1)
        this.waiting.add(element)
    }
}



Queue.prototype.removingNext = function (count) {
    if (this.empty()) {
        return null
    }

    let removing
    if (count) {
        removing = this.elements.splice(0, count)
        for (let i = 0; i < removing.length; i++) {
            this.waiting.add(removing[i])
        }
        removing.forEach(element => this.waiting.add(element))
    } else {
        removing = this.elements.shift()
        this.waiting.add(removing)
    }
    return removing
}



Queue.prototype.handleSync = function (handler) {
    while (!this.empty()) {
        handler(this.removeNext())
    }
}


Queue.prototype.handleInSerie = function (handler) {
    if (this.empty()) {
        return
    }

    let element = this.removingNext()

    handler(element, () => {
        this.remove(element)
        this.handleInSerie(handler)
    })

}



Queue.prototype.handleInParallel = function (handler) {

    while (!this.empty()) {
        handleNextInParallel(this, handler)
    }

}


function handleNextInParallel (queue, handler) {
    let element = queue.removingNext()
    handler(element, function () {
        queue.remove(element)
        queue.handleInParallel(handler)
    })
}



function checkFinished (queue) {
    if (queue.onFinished && queue.finished()) {
        queue.onFinished()
    }
}


export default Queue
